import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '@optsolservices/ngx-notification';
import { GeneralStoreService } from '../store/general.store';
import { Router } from '@angular/router';
import { ApiResponse } from '../models/api-response';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private generalStoreService: GeneralStoreService,
    private notificationService: NotificationService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(tap((response: HttpResponse<ApiResponse<any>>) => {

        if (response.status === 200
          && typeof response.body.responseCode !== 'undefined') {

          if (response.body.responseCode !== 0) {
            if (response.body.responseMessage === 'undefined') {
              this.notificationService.error('Something went wrong, please contact support.');
            } else {
              this.notificationService.error(this.pretifyErrorMessage(response.body.responseMessage));
            }
          } else {
            if (response.body.responseMessage) {
              this.notificationService.success(this.pretifyErrorMessage(response.body.responseMessage));
            }
          }
        }

      }))
      .pipe(catchError(response => {

        if (response.status === 401) {
          this.notificationService.error("Session Expired");
          this.generalStoreService.logout();
          this.router.navigate(['/']);
        } else {
          // Invalid login credentials:
          if (response?.error?.error === 'invalid_grant' && response?.error?.error_description) {
            this.notificationService.error(response.error.error_description);
          } else {
            // Generic error:
            this.notificationService.error(`An error occured: ${response?.error?.responseMessage || response?.message}`);
          }

        }

        return throwError(response);
      }));
  }

  pretifyErrorMessage(message: string) {
    if (!message) return '';

    message = message.replace('Error caught in dbo.api_entry_point:', '')

    const index = message.indexOf('(Procedure id');
    if (index > -1) {
      message = message.substring(0, index);
    }

    return message;

  }
}
